<template>
  <div class="row">
    <div class="col-12">
      <div class="row" v-if="Object.keys(chartData).length > 0">
        <div class="col-lg-6 mb-4 order-1 order-lg-1">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title mb-4 d-flex justify-content-between">
                <span>{{year}}年{{month}}月の視聴回数</span>
                <span>合計: {{total_views}}回</span>
              </h4>
              <bar-chart :chartdata="chartData.views" chart_id="viewed_of_day" bar_label="視聴回数" :bar_color="bar_color"></bar-chart>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-4 order-3 order-lg-2">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title mb-4">{{year}}年{{month}}月の視聴時間</h4>
              <bar-chart :chartdata="chartData.watched" chart_id="average_viewing" bar_label="視聴回数" :bar_color="bar_color"></bar-chart>
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-2 order-lg-3">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr class="text-center">
                      <th>日</th>
                      <th>視聴回数</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(c, index) in chartData.views">
                      <td class="align-middle"><a :href="'/' + report_pathname + '/videos/' + videoId + '/report/years/' + year + '/monthes/' + month + '/days/' + (index + 1)">{{c.label}}</a></td>
                      <td class="align-middle text-right">
                        <a class="btn btn-light btn-block" :href="'/' + report_pathname + '/videos/' + videoId + '/viewed_videos?date_from=' + year + '-' + month  + '-' + (index + 1) + '&date_to=' + year + '-' + month + '-' + (index + 1)">{{c.total}}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-4 order-lg-4">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr class="text-center">
                      <th>タイムスタンプ</th>
                      <th>視聴回数</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="c in chartData.watched">
                      <td>{{c.label}}</td>
                      <td class="text-right">{{c.total}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';
import BarChart from "../BarChart";
export default {
  props: {
    api_pathname: {
      type: String,
      default: ""
    },
    report_pathname: {
      type: String,
      default: ""
    },
    bar_color: {
      type: String,
      default: "#2196f3"
    },
  },
  components: {BarChart},
  data() {
    return {
      encodedOrganizationId: null,
      videoId: null,
      total_views: 0,
      month: null,
      year: null,
      chartData: {},
    }
  },
  methods: {
    async init() {
      const arrPath     = window.location.pathname.split("/")
      this.encodedOrganizationId      = arrPath.slice(-8)[0]
      this.videoId      = arrPath.slice(-6)[0]
      this.month  = await  arrPath.slice(-1)[0]
      this.year   = await  arrPath.slice(-3)[0]

      this.getVideoReport()
    },
    async getVideoReport() {
      await this.axios.get('/api/v1/' + this.api_pathname + '/videos/' + this.videoId + '/report/years/' + this.year + '/monthes/' + this.month).then((response) => {
        this.chartData = response.data.chartdata
        this.chartData.views.forEach((v) => {this.total_views +=  v.total})
      }).catch((error) => {
      })
    },
  },
  async mounted() {
    this.init()
  }
}
</script>
